"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Impressum = exports.Datenschutz = exports.Danke = void 0;
var component_1 = __importDefault(require("@loadable/component"));
var Danke = component_1.default(function () { return Promise.resolve().then(function () { return __importStar(require('./Danke')); }); });
exports.Danke = Danke;
var Datenschutz = component_1.default(function () { return Promise.resolve().then(function () { return __importStar(require('./Datenschutz')); }); });
exports.Datenschutz = Datenschutz;
var Impressum = component_1.default(function () { return Promise.resolve().then(function () { return __importStar(require('./Impressum')); }); });
exports.Impressum = Impressum;
__exportStar(require("./Danke"), exports);
__exportStar(require("./Datenschutz"), exports);
__exportStar(require("./Impressum"), exports);
//# sourceMappingURL=index.js.map